<!-- Translated: yes -->
<template>
  <div class="item">
    <div class="item-header" @click="toggle()">
      {{ title }}
      <span v-if="isActive()" class="icon">-</span>
      <span v-else @click.stop="toggle()" class="icon">+</span>
    </div>
    <div v-show="isActive()" class="item-body" v-html="content">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
    },
    content: {
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
    isActive() {
      return this.expanded;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.item
  border: 2px solid pink
  border-radius: 4px
  padding: .5em 1em;
  margin-bottom: 1em;
  width: 100%
  text-align: left
  display block

  .item-header
    @extend .uppercase, .bold
    display: flex
    justify-content: space-between
    cursor pointer;

    .icon
      color: red
      flex-grow: 0
      cursor: pointer
      margin-left: 1em
      font-size: 2em
</style>



// WEBPACK FOOTER //
// Collapsable.vue?7d7d1a8a